import authorizationTokenService from '../services/authorizationToken.service';

const authorizationTokens = {
    namespaced: true,
    state: {},
    actions: {
        //CREATE
        requestNew(_,params) {
            return authorizationTokenService.requestNew(params.entityType, params.entityId, params.isNewEntity);
        },

        //READ


        //UPDATE

        //DELETE
    },
    getters: {},
    mutations: {},
};

export default authorizationTokens;
